// ============================================
// device_token — "thiết bị tin cậy" của đăng nhập 2FA email
// (docs/ADMIN_2FA_EMAIL.md §4)
//
// Lưu localStorage và gửi qua header `X-Device-Token` ở MỌI lần gọi
// /auth/admin/login/. KHÔNG dựa vào cookie `conai_admin_device` của BE:
// web admin và API khác origin nên đó là cookie cross-site, trình duyệt chỉ
// giữ khi chạy HTTPS — dev chạy HTTP là cookie bị bỏ.
//
// Chủ đích KHÔNG xoá khi logout: lòng tin gắn với trình duyệt, không gắn với
// phiên. Chỉ xoá khi người dùng đổi / đặt lại mật khẩu — BE thu hồi toàn bộ
// thiết bị tin cậy lúc đó, giữ token cũ chỉ để gửi lên một chuỗi đã chết.
// ============================================

const DEVICE_TOKEN_KEY = 'conai_admin_device_token';

/** try/catch vì localStorage có thể ném (private mode, storage bị chặn). */
export function getDeviceToken(): string | null {
  try {
    return localStorage.getItem(DEVICE_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setDeviceToken(token: string): void {
  try {
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
  } catch {
    // Không lưu được thì lần sau bị hỏi mã lại — phiền, không phải lỗi.
  }
}

export function clearDeviceToken(): void {
  try {
    localStorage.removeItem(DEVICE_TOKEN_KEY);
  } catch {
    // ignore
  }
}
